/**
 * Auto-generated SMRT Components
 *
 * This file is automatically generated by the SMRT Vite plugin.
 * It exports UI components that are auto-generated from @smrt() decorated classes.
 *
 * DO NOT EDIT THIS FILE MANUALLY - it will be overwritten.
 */

// Self-register this package's manifest for consumers that import via this
// subpath without the main entry. See src/__smrt-register__.ts (issue #1132).
import '../../__smrt-register__.js';

// Auto-generated components will be exported here by the SMRT Vite plugin
// Examples:
// export { default as SmrtProductForm } from './SmrtProductForm.svelte';
// export { default as SmrtProductTable } from './SmrtProductTable.svelte';
// export { default as SmrtCategoryForm } from './SmrtCategoryForm.svelte';

// For now, export an empty object to prevent import errors
export const autoGeneratedComponents = {};
